import { useMemo } from "react";

import { SearchOverviewTexts } from "../../texts";
import GenericWidgetTable from "../GenericWidgetTable/GenericWidgetTable";

import useBrandedTrafficDataTable from "./hooks/useBrandedTrafficDataTable";
import { getBrandedSplitColumns } from "./tableColumns";

const BrandedTrafficTable = () => {
    const { data, isLoading, isError } = useBrandedTrafficDataTable();
    const columnConfig = useMemo(
        () => (data.length > 0 && !isLoading ? getBrandedSplitColumns() : []),
        [data, isLoading],
    );

    return (
        <GenericWidgetTable
            data-automation="search-overview-branded-traffic-table"
            tableProps={{ data, isLoading, columnConfig }}
            title={SearchOverviewTexts.brandedTrafficTitle}
            tooltip={SearchOverviewTexts.brandedTrafficTooltip}
            isError={isError}
        />
    );
};

export default BrandedTrafficTable;
